export default __webpack_public_path__ + "static/media/close-circle.3262ff6c.svg";